"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftHeaderBase_styles_1 = require("./LftHeaderBase.styles");
var LftIconButton_1 = __importDefault(require("../LftIconButton"));
var menu_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/menu"));
var LftHeaderBase = function (_a) {
    var _b = _a.alt, alt = _b === void 0 ? 'LftLogotipo' : _b, ariaLabelLedBy = _a.ariaLabelLedBy, _c = _a.bgColor, bgColor = _c === void 0 ? false : _c, dataSection = _a.dataSection, dataTestId = _a.dataTestId, _d = _a.hiddenMenuButton, hiddenMenuButton = _d === void 0 ? false : _d, id = _a.id, _e = _a.tabIndex, tabIndex = _e === void 0 ? 0 : _e, _f = _a.version, version = _f === void 0 ? 'default' : _f, lftClick = _a.lftClick;
    var dataElement = dataSection === null || dataSection === void 0 ? void 0 : dataSection.replace('section_', '');
    var _handleClick = function (e) {
        lftClick && lftClick(e);
    };
    if (dataSection) {
        if (dataSection.startsWith('section_')) {
            console.warn('Não é necessário mais o prefixo section_ no atributo dataSection');
        }
        else
            (dataSection = "section_".concat(dataSection));
    }
    return ((0, jsx_runtime_1.jsxs)(LftHeaderBase_styles_1.HeaderBaseStyled, __assign({ bgColor: bgColor, "data-lift": "lft-headerbase", "data-section": dataSection, "data-testid": dataTestId ? dataTestId : id && id, hiddenMenuButton: true, id: id, tabIndex: tabIndex, version: version, onClick: _handleClick }, { children: [!hiddenMenuButton && (0, jsx_runtime_1.jsx)(LftIconButton_1.default, { dataElement: dataSection && ('toggler-' + dataElement), icon: menu_1.default, size: "lg" }), (0, jsx_runtime_1.jsx)(LftHeaderBase_styles_1.LogoStyled, { alt: alt, "aria-labelledby": ariaLabelLedBy, version: version })] })));
};
exports.default = LftHeaderBase;
